module.exports = __webpack_public_path__ + "static/media/paste-html-email-blockify.02ef0aab.gif";